import React, {useState} from "react";
import "./Weather.css"
import axios from "axios";
import FormattedDate from "./FormattedDate";
import WeatherTemperature from "./WeatherTemperature";
import WeatherForecast from "./WeatherForecast";



export default function Weather(props) {

const [city, setCity]=useState (props.defaultCity);
const [weatherData, setWeatherData]=useState({ready:false});

    function handleResponse(response) {
      
        setWeatherData({
            ready:true, 
            cityResponse:response.data.city,
            coordinates:response.data.coordinates,
            temperature:response.data.temperature.current,
            wind: response.data.wind.speed,
            humidity:response.data.temperature.humidity,
            description: response.data.condition.description,
            date:new Date(response.data.time *1000),
            iconUrl:`http://shecodes-assets.s3.amazonaws.com/api/weather/icons/${response.data.condition.icon}.png` 
        
        });
    }


function search() {
   const apiKey="e8to4a8c7230336a2148815f4516b5f1";
    let apiUrl=`https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
     
}

function handleSubmit(event) {
event.preventDefault();
search();
}

function handleCityChange (event) {
setCity(event.target.value);
}

if(weatherData.ready) {
    return(
        <div className="Weather">
            <div className="row">
                <div className="col-4 city">
            <h1>
                {weatherData.cityResponse}
            </h1>

            <WeatherTemperature celsius={weatherData.temperature} />
                    
                <form onSubmit={handleSubmit} >
                    <input type="search" placeholder="Enter a city" autofocus="on" autocomplete="off" className="city-name" onChange={handleCityChange} />
                    <input type="submit" value="Search" className="searching" />
                   </form>
                </div>
               
                <div className="col-4">
           <p class="current-time">
                  <FormattedDate date={weatherData.date} />
                </p>
                <p className="sun text-capitalize">
                    {weatherData.description}
                </p>

                <img src={weatherData.iconUrl} className="icon" alt="Weather icony" />

        </div>
                <div className="col-4">
            <ul>
                    <li>
                        Humidity
                        <br />
                        <span>{weatherData.humidity} %</span>
                    </li>

                    <li>
                        Wind speed
                        <br />
                        <span> {Math.round(weatherData.wind)} km/h</span>
                    </li>
                </ul>
        </div>
</div>
<WeatherForecast coordinates={weatherData.coordinates} />
</div>
    );
} else {
 
search()
    return "Loading...";
}
}